import { useEffect, useRef, useState } from "react";

// Which soundtrack section (if any) sits under the middle of the screen.
export function useActiveSection(ids, enabled) {
  const [active, setActive] = useState(null);
  const key = ids.join(",");

  useEffect(() => {
    if (!enabled || !key) { setActive(null); return undefined; }
    const list = key.split(",");
    let raf = 0;
    const check = () => {
      raf = 0;
      const mid = window.innerHeight / 2;
      const hit = list.find((id) => {
        const r = document.getElementById(id)?.getBoundingClientRect();
        return r && r.top <= mid && r.bottom >= mid;
      });
      setActive(hit || null);
    };
    const onScroll = () => { if (!raf) raf = requestAnimationFrame(check); };
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    const t = setTimeout(check, 800);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
      clearTimeout(t);
      if (raf) cancelAnimationFrame(raf);
    };
  }, [key, enabled]);

  return active;
}

// Switches to a section's song while the visitor is already listening; otherwise offers a tap-to-play prompt.
export function useSectionSoundtracks(s, sections, enabled) {
  const active = useActiveSection(Object.keys(sections), enabled);
  const latest = useRef(s);
  latest.current = s;
  const [dismissed, setDismissed] = useState([]);

  useEffect(() => {
    const p = latest.current;
    if (!p.playing) return;
    if (active && p.section !== active) p.fadeToSection(active);
    else if (!active && p.section) p.fadeToQueue();
  }, [active]);

  const prompt = !s.started && active && !dismissed.includes(active) ? active : null;
  return { prompt, dismiss: () => setDismissed((d) => [...d, active]) };
}
